// store/loader.js (Pinia example)
import { defineStore } from "pinia";

export const useLoaderStore = defineStore("loader", {
  state: () => ({
    isLoading: false,
    activeRequests: 0,
  }),
  actions: {
    startLoading() {
      // console.log("startLoading");
      this.activeRequests++;
      this.isLoading = true;
    },
    stopLoading() {
      // console.log("stopLoading");
      this.activeRequests--;
      if (this.activeRequests <= 0) {
        this.isLoading = false;
      }
    },
  },
});
